var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { runtime } from '../../../../classes/runtime/Runtime';
let MenubarUseronline_ = class MenubarUseronline_ extends React.PureComponent {
    get color() {
        if (this.props.app.menubar.menubarOnlinecounter.isOnlineMenuOpen) {
            return '#fff';
        }
        return '#9d9d9d';
    }
    get background() {
        if (this.props.app.menubar.menubarOnlinecounter.isOnlineMenuOpen) {
            return 'linear-gradient(to bottom, #080808 0%, #0f0f0f 100%)';
        }
        return undefined;
    }
    get placeholder() {
        return React.createElement("div", { style: { minWidth: 115 } });
    }
    get displayText() {
        const { app } = this.props;
        if (!app.appOnlineCount)
            return '';
        if (!app.appOnlineCount.platformCounts)
            return '';
        return `${app.appOnlineCount.platformCounts.online_total} Nutzer online`;
    }
    render() {
        const { app } = this.props;
        if (!app.appOnlineCount)
            return this.placeholder;
        if (app.appMeasure.appWidthInPixel < 1100)
            return null;
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: {
                    minWidth: 115,
                    height: 45,
                    paddingLeft: 10,
                    paddingRight: 10,
                    marginRight: 10,
                    display: 'flex',
                    alignItems: 'center',
                    textShadow: '0 -1px 0 rgba(0,0,0,0.25)',
                    fontSize: 13,
                    color: this.color,
                    background: this.background,
                    cursor: 'pointer'
                }, onClick: app.menubar.menubarOnlinecounter.toggleOnlinecounterMenu }, this.displayText),
            this.userOnlineMenu));
    }
    get userOnlineMenu() {
        const { app } = this.props;
        if (!app.menubar.menubarOnlinecounter.isOnlineMenuOpen)
            return null;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { MenubarUseronlineMenu } = runtime.streamedPackages.Lazy.components;
        return React.createElement(MenubarUseronlineMenu, { app: app });
    }
};
MenubarUseronline_ = __decorate([
    observer
], MenubarUseronline_);
export { MenubarUseronline_ };
